import { ContactBook } from '@/plugins/api'

export default {
  namespaced: true,
  state: {},
  actions: {
    async sendMarkNotification(_, params) {
      await ContactBook.sendMarkNotification(params)
    },
    async sendDailyViolation(_, params) {
      await ContactBook.sendDailyViolation(params)
    },
    async sendTuitionFeePeriodNoti(_, params) {
      await ContactBook.sendTuitionFeePeriodNoti(params)
    },
    async sendTuitionFeePeriod(_, params) {
      let res = await ContactBook.sendTuitionFeePeriod(params)
      return res
    },
    async getProgressTuitionFeePeriod(_, params) {
      let res = await ContactBook.getProgressTuitionFeePeriod(params)
      return res
    },
  },
  mutations: {},
  getters: {}
}
